import React, { useState, useEffect, useContext, useRef } from 'react'; /*st48236 - 508 compliance*/
import 'bootstrap/dist/css/bootstrap.min.css';
import Card from "./card";
import RecentPayments from "./recentPayments";
import { getApiService } from "../services/ApiService";
import { Spinner } from "react-bootstrap";
import { GetPayLoad } from "../services/PayLoadStorage";
import { LanguageContext } from "../contexts/LanguageContext";
import Cookies from 'js-cookie';

const Billing = (props) => {
    
    const [thruDate, setThruDate] = useState('N/A');
    const [isThruDateLoading, setThruDateLoading] = useState(true);

    const [recentPayments, setRecentPayments] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const Payload = GetPayLoad('PayLoad');

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region,
        "X-Hps-Carrier": Payload?.owning_carrier
      };

    const { pageContent } = useContext(LanguageContext);
    const [billingContent, setBillingContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);
    const [errorFlag, setErrorFlag] = useState(false);
    const [thruDateErrorFlag, setThruDateErrorFlag] = useState(false);
    const [autopayAccount, setAutopayAccount] = useState([]);
    const [autopayStatus, setAutopayStatus] = useState('Enable');
    const mainRef = useRef(null); // Reference for the live region /*st48236 - 508 compliance*/
    const [isContentReady, setContentReady] = useState(false); // st48236 - 508 compliance Track when all API responses are received
    const [apiCallsCompleted, setApiCallsCompleted] = useState(false); // st48236 - 508 compliance Track when all API calls are completed
    const [caseInfo, setCaseInfo] = useState([]);
    
    const [billHistoryIcon, setBillHistoryIcon] = useState(null);
    const [billPrefIcon, setBillPrefIcon] = useState(null);
    const [payHistoryIcon, setPayHistoryIcon] = useState(null);
    const [schedulePayIcon, setSchedulePayIcon] = useState(null);
    const [payAuthIcon, setPayAuthIcon] = useState(null);
    const [autoPayIcon, setAutoPayIcon] = useState(null);
    const [readOnlyMode, setReadOnlyMode] = useState(false);

    // Set icons based on owning carrier
    useEffect(() => {

        // Check for read-only mode based on owning carrier or any other condition
        setReadOnlyMode(Payload?.readOnlyAccess === true);

        const connectiCareCarrier = Cookies.get("connectiCareCarrier") || null;
        const isConnectiCareCarrier = Cookies.get("isConnectiCareCarrier") || 'false';
        
        // When ConnectiCare carrier is set, override owningCarrier
        let owningCarrier = Payload?.owning_carrier || '';
        owningCarrier = ( isConnectiCareCarrier === 'true' && connectiCareCarrier !== null && connectiCareCarrier !== undefined) ? connectiCareCarrier : owningCarrier;        
        
        import('../assets/images/Billing/Billing-History-'+owningCarrier+'.svg').then((image) => {
            setBillHistoryIcon(image.default);
        }).catch(() => {
            import('../assets/images/Billing/Billing-History.svg').then((image) => {
                setBillHistoryIcon(image.default);
            });
        });

        import('../assets/images/Billing/Billing-Preference-'+owningCarrier+'.svg').then((image) => {
            setBillPrefIcon(image.default);
        }).catch(() => {
            import('../assets/images/Billing/Billing-Preference.svg').then((image) => {
                setBillPrefIcon(image.default);
            });
        });

        import('../assets/images/Billing/Payment-History-'+owningCarrier+'.svg').then((image) => {
            setPayHistoryIcon(image.default);
        }).catch(() => {
            import('../assets/images/Billing/Payment-History.svg').then((image) => {
                setPayHistoryIcon(image.default);
            });
        });

        import('../assets/images/Billing/Schedule-payment-'+owningCarrier+'.svg').then((image) => {
            setSchedulePayIcon(image.default);
        }).catch(() => {
            import('../assets/images/Billing/Schedule-payment.svg').then((image) => {
                setSchedulePayIcon(image.default);
            });
        });
        import('../assets/images/Billing/Payment-Auth-'+owningCarrier+'.svg').then((image) => {
            setPayAuthIcon(image.default);
        }).catch(() => {
            import('../assets/images/Billing/Payment-Auth.svg').then((image) => {
                setPayAuthIcon(image.default);
            });
        });

        import('../assets/images/Billing/Autopay-'+owningCarrier+'.svg').then((image) => {
            setAutoPayIcon(image.default);
        }).catch(() => {
            import('../assets/images/Billing/Autopay.svg').then((image) => {
                setAutoPayIcon(image.default);
            });
        });

    }, [Payload?.owning_carrier]);
        

    useEffect(() => {
        if (pageContent?.billing) {
            setBillingContent(pageContent.billing);
        }

        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }
        
    }, [pageContent]);

    const columns = [billingContent?.billing_recent_payments_total_amount_due_text, billingContent?.billing_recent_payments_pending_adjustment_text, billingContent?.billing_recent_payments_payments_text, billingContent?.billing_recent_payments_net_due_text]

    useEffect(() => {
        //Get Case Info and set Case Info to Card
        const targetCaseUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
        getApiService(baseUrl, targetCaseUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                if (response?.data?.statusCode !== 200) {
                    console.error('Error fetching case info');
                } else {
                    const result = response.data.data;
                    setCaseInfo(result);
                }
            })
            .catch(error => {
                console.error('Error fetching case info:', error);
            });
            
        //Get Recent Payments
        const targetUrl = process.env.REACT_APP_API_RECENT_PAYMENTS_ENDPOINT;
        getApiService(baseUrl, targetUrl, { cim: Payload?.cim, case_num: Payload?.case_num }, headers)
            .then((response) => {
                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                }else{
                    const result = response?.data?.data;
                    setErrorFlag(false);
                    setRecentPayments(result);
                    setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed 
                }
            })
            .catch(error => {
                setLoading(false);
                setErrorFlag(true);
            });

        //Get Thru Date
        const targetCaseAmountUrl = process.env.REACT_APP_API_CASE_BILL_DETAILS_ENDPOINT;
        getApiService(baseUrl, targetCaseAmountUrl, { cim: Payload?.cim, apiSource: 'thruDate' }, headers)
            .then((response) => {
                setThruDateLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setThruDateErrorFlag(true);
                }else{
                    setThruDateErrorFlag(false);
                    setThruDate(response.data.data?.PaidThruDate || 'N/A');
                    setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed 
                }
            })
            .catch(error => {
                setThruDateLoading(false);
                setThruDateErrorFlag(true);
            });
        
        getAutopayStatus();

    }, [autopayStatus]);

    function getAutopayStatus(){
        const targetGetAutopayStatusUrl = process.env.REACT_APP_API_GET_AUTOPAY_STATUS_ENDPOINT;
        getApiService(baseUrl, targetGetAutopayStatusUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                }else{
                    setErrorFlag(false);
                    const result = response.data.data;
                    setAutopayAccount(result);
                    if(result?.count > 0 || result?.autopay_status === 'Y'){
                        let autopay_status = 'Disable';
                        setAutopayStatus(autopay_status);
                    }
                    setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed 
                }
            })
            .catch(error => {
                setErrorFlag(true);
            });
    }

    function handleDataFromCard(modalText){
        setAutopayStatus(modalText);
    }  

    
    /*st48236 - 508 compliance*/
    
        const [userInteracted, setUserInteracted] = useState(false);
        
        useEffect(() => {
          const handleUserInteraction = () => {
            setUserInteracted(true);
          };
        
          // Listen for user interactions
          document.addEventListener('click', handleUserInteraction);
          document.addEventListener('keydown', handleUserInteraction);
          
          return () => {
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('keydown', handleUserInteraction);
          };
        }, []);
        
        useEffect(() => {
          let timeoutId;
          
          if (apiCallsCompleted && !isContentReady) {
            timeoutId = setTimeout(() => {
              setContentReady(true);
              
              // Only auto-focus if user hasn't interacted
              if (!userInteracted && mainRef.current) {
                requestAnimationFrame(() => {
                  mainRef.current.focus({ preventScroll: true });
                });
              }
            }, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT));
          }
          
          return () => {
            if (timeoutId) clearTimeout(timeoutId);
          };
        }, [apiCallsCompleted, isContentReady, userInteracted]);
  
    return (
        <main
		role="main"
		tabIndex="-1" // Make the <main> tag focusable
		ref={mainRef} // Attach the ref to the <main> tag
        style={{ outline: 'none' }} // revmove border
		aria-label="Billing"
        > {/*st48236 - 508 compliance*/}
        <div>
            <div className="conatiner-fluid content-inner mt-n5 py-0">
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <div className="row">
                            {billHistoryIcon && billPrefIcon && payHistoryIcon && schedulePayIcon && payAuthIcon && autoPayIcon && (
                                <>
                                    <div className="d-xl-flex d-md-flex d-sm-flex mb-2">
                                        <Card image={billHistoryIcon} description='billingHistory' heading={billingContent?.billing_menu_billing_history_title} subHeading={billingContent?.billing_menu_billing_history_desc} caseInfo={caseInfo} />
                                        <Card image={billPrefIcon} description='billingPreference' heading={billingContent?.billing_menu_billing_preference_title} subHeading={billingContent?.billing_menu_billing_preference_desc} caseInfo={caseInfo} sendDataToBilling={handleDataFromCard} />
                                        <Card image={payHistoryIcon} description='paymentHistory' heading={billingContent?.billing_menu_payment_history_title} subHeading={billingContent?.billing_menu_payment_history_desc} caseInfo={caseInfo}/>
                                    </div>
                                    <div className="d-xl-flex d-md-flex d-sm-flex">
                                        {!readOnlyMode && (
                                            <Card image={schedulePayIcon} description='schedulePayment' heading={billingContent?.billing_menu_schedule_payment_title} subHeading={billingContent?.billing_menu_schedule_payment_desc} caseInfo={caseInfo}/>
                                        )}
                                        <Card image={payAuthIcon} description='paymentAuth' heading={billingContent?.billing_menu_payment_auth_title} subHeading={billingContent?.billing_menu_payment_auth_desc} caseInfo={caseInfo}/>
                                        {!readOnlyMode && (
                                            <Card image={autoPayIcon} description='autopay' heading={billingContent?.billing_menu_autopay_enable_text !== undefined ? ((autopayStatus === 'Enable') ? billingContent?.billing_menu_autopay_enable_text : billingContent?.billing_menu_autopay_disable_text)+' '+billingContent?.billing_menu_autopay_title : ''} subHeading={billingContent?.billing_menu_enable_autopay_desc} sendDataToBilling={handleDataFromCard} caseInfo={caseInfo} />
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-12 rcnt-payment">
                        <div className="row">
                            <div className="d-flex mt-3">
                                <div className="col-4 px-3" tabIndex={0}>
                                    <h5 className="fw-semibold reacentpayments">{billingContent?.billing_recent_payments_title}</h5>
                                </div>
                                {!thruDateErrorFlag && !isThruDateLoading && (
                                <div className="col-8 text-end px-3" tabIndex={0}>
                                    {thruDate && (
                                        <span className="d-inline-block me-2">
                                            {/* <img src={print} className="me-2"
											alt="Print" /> */}
                                            <h4 className="d-inline thru-date">{billingContent?.billing_recent_payments_thru_date_text} : {thruDate}</h4>
                                        </span>
                                    )}

                                    {/* <button type="submit" className="btn btn-outline-primary me-2 reacentpaybutton">
										Download PDF
										<i className="fe fe-download fe-15 align-middle"></i>
									</button>
									<button type="submit" className=" btn btn-outline-primary reacentpaybutton">
										Download Spreadsheet
										<i className="fe fe-download fe-15 align-middle"></i>
									</button> */}
                                </div>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            {errorFlag && (
                                <div className="api-error-msg">
                                    {genericContent?.finance_service_error}
                                </div>
                            )}
                            {isLoading && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                    <Spinner animation="border" role="status" ></Spinner>
                                    <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                </div>
                            )}
                            {!isLoading && !errorFlag && recentPayments && (
                                <div className="px-xl-4 mb-4">
                                    <div className="bd-example table-responsive d-grid-tbl mt-4">
                                        <RecentPayments columns={columns} rows={recentPayments} />
                                        
                                    </div>
                                </div>
                            )}

                        </div>

                    </div>
                </div>
            </div>
        </div>
        </main>
    );
}
export default Billing;